<template>
	<div>
		<breadcrumb :routerList="[{to:'/personal/angentDetail',title:'个人中心'},{title:'基本信息'}]"/>
		<div class="h-content">
			<div class="h-row h-mrt0">
				<div class="h-rowIn">
					<div class="h-rowBox zizhi">
						<div class="containImgBox">
<!--							<div class="headBox">-->
<!--								<img src="../../assets/images/defaultHead.png" alt="">-->
<!--							</div>-->
<!--							<div class="btngroup">-->
<!--								<el-button class="h-btn h-bBtn h-bgwhite">上传头像</el-button>-->
<!--								<el-button @click="tuichu" class="h-btn h-bBtn h-bgblueQ2">退出登录</el-button>-->
<!--							</div>-->
						</div>
							<div class="h-formLine" style="margin-top:0.38rem">
								<el-form :model="supplierData" label-position="right" ref="supplierData" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
									<div class="h-rowCon">
										<div class="h-pieceIn2">
											<!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
											<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
												<h1>基本信息</h1>
											</div>

											<div class="h-pieceCon2">
												<div class="h-formLine weekplandetail">
													<el-form-item label="供应商名称" class="h-elformWrap-2" prop="userName">
														<el-input placeholder="" v-model="supplierData.userName" readonly></el-input>
													</el-form-item>
<!--													<el-form-item label="供应商账户组" class="h-elformWrap-2" prop="">-->
<!--														<el-input placeholder="请输入" v-model="supplierData.InAccountGrpCode" readonly></el-input>-->
<!--													</el-form-item>-->
													<el-form-item label="公司代码" class="h-elformWrap-2" prop="">
														<el-input placeholder="" v-model="supplierData.subCompany" readonly></el-input>
													</el-form-item>
													<el-form-item label="电话" class="h-elformWrap-2" prop="inPhoneNumber">
														<el-input placeholder="" v-model="supplierData.inPhoneNumber" readonly></el-input>
													</el-form-item>
													<el-form-item label="国家" class="h-elformWrap-2" prop="inCountry">
														<brselectlazy class="ljjSelectdisabled" category="YLCountry_agent" :v="supplierData.inCountry" v-model="supplierData.inCountry" :clearable="true" disabled
																	  style="width:100%" />
													</el-form-item>
													<el-form-item label="地区" class="h-elformWrap-2" prop="inRegion" v-if="this.supplierData.inCountry == 'CN'">
														<brselectlazy class="ljjSelectdisabled" category="YLRegion" :v="supplierData.inRegion" v-model="supplierData.inRegion" :clearable="true" disabled
																	  style="width:100%" />
													</el-form-item>
												</div>
											</div>
										</div>
										<div class="h-pieceIn2">
											<!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
											<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
												<h1>公司信息</h1>
											</div>
											<div class="h-pieceCon2">
												<div class="h-formLine weekplandetail">
													<el-form-item label="公司代码" class="h-elformWrap-2" prop="">
														<brselectlazy class="ljjSelectdisabled" category="YlCompanyCode_agent" :v="supplierData.companyCode" v-model="supplierData.companyCode" :clearable="true" disabled
																	  style="width:100%" />
													</el-form-item>
													<el-form-item label="法人" class="h-elformWrap-2" prop="reconcileAccount">
														<el-input placeholder="请输入" maxlength="20" v-model="supplierData.legalPerson" disabled></el-input>
													</el-form-item>
													<el-form-item label="联系人" class="h-elformWrap-2" prop="paymentTerm">
														<el-input placeholder="请输入" maxlength="20" v-model="supplierData.contacts" disabled></el-input>
													</el-form-item>
													<el-form-item label="地址" class="h-elformWrap-2" prop="paymentMethod">
														<el-input placeholder="请输入" maxlength="100" v-model="supplierData.address" disabled></el-input>
													</el-form-item>
													<el-form-item label="生产许可证号" class="h-elformWrap-2" prop="paymentMethod">
														<el-input placeholder="请输入" maxlength="30" v-model="supplierData.productionLicense" disabled></el-input>
													</el-form-item>
													<el-form-item label="质量抽检" class="h-elformWrap-2" prop="isQuality" required>
														<el-select v-model="supplierData.isQuality" disabled style="width:100%">
															<el-option value="1" label="是"></el-option>
															<el-option value="0" label="否"></el-option>
														</el-select>
													</el-form-item>
												</div>
											</div>
										</div>
										<div class="h-pieceIn2">
											<!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
											<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
												<h1>银行信息</h1>
											</div>
											<div class="h-pieceCon2">
												<div class="h-formLine weekplandetail">
													<el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry">
														<brselectlazy class="ljjSelectdisabled" category="YLCountry_agent" :v="supplierData.bankCountry" v-model="supplierData.bankCountry" :clearable="true" disabled
																	  style="width:100%" />
													</el-form-item>
													<el-form-item label="所属银行" class="h-elformWrap-2"  prop="accountHolderName">
														<el-input placeholder="" v-model="supplierData.accountHolderName" readonly></el-input>
													</el-form-item>
													<el-form-item label="银行户主" class="h-elformWrap-2" prop="bankAccountNum">
														<el-input placeholder="" v-model="supplierData.bankAccountNum" readonly></el-input>
													</el-form-item>
													<el-form-item label="银行账户" class="h-elformWrap-2"  prop="accountHolderName">
														<el-input placeholder="" v-model="supplierData.accountHolderName" readonly></el-input>
													</el-form-item>
													<el-form-item label="订单货币" class="h-elformWrap-2"  prop="orderCurrency">
														<brselectlazy class="ljjSelectdisabled" category="YLCurrency" :v="supplierData.orderCurrency" v-model="supplierData.orderCurrency" :clearable="true" disabled
																	  style="width:100%" />
													</el-form-item>
													<el-form-item label="采购组织" class="h-elformWrap-2" prop="purchaseGrpCode" >
														<el-input placeholder="" v-model="supplierData.purchaseGrpCode" readonly></el-input>
													</el-form-item>
													<el-form-item label="PI合作伙伴" class="h-elformWrap-2"  prop="partnerPi">
														<el-input placeholder="" v-model="supplierData.partnerPi" readonly></el-input>
													</el-form-item>
												</div>
											</div>
										</div>
										<!--<div class="h-pieceIn2">
											&lt;!&ndash; <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> &ndash;&gt;
											<div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
												<h1>资质信息</h1>
											</div>
											<div class="h-pieceCon2 ">
												<div class="h-formLine ">
													<div class="upload ">
														<el-form-item label="查看营业执照凭证" class="h-elformWrap-1" prop="upload">
															<brupload
																v-if="isShow"
																:refid = "refid"
																reftype = "供应商注册-营业执照信息"
																>
															</brupload>
														</el-form-item>
													</div>
													<div class="upload">
														<el-form-item label="查看二级资质凭证" class="h-elformWrap-1" prop="upload">
															<brupload
																v-if="isShow"
																:refid = "refid"
																reftype = "供应商注册-二级资质信息"
																>
															</brupload>
														</el-form-item>
													</div>
													<div class="upload">
														<el-form-item label="查看三级资质凭证" class="h-elformWrap-1" prop="upload">
															<brupload
																v-if="isShow"
																:refid = "refid"
																reftype = "供应商注册-二级资质信息"
																>
															</brupload>
														</el-form-item>
													</div>
												</div>
											</div>
										</div>-->
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="goBack">返回</el-button>
			</div>
		</div>
</template>

<script>
	import supplierListService from "../../api/personal/supplierListService";

export default {
	data(){
      return{
		  isShow: false,
      	refid: null,
          //带线表单
            value:false,
		  queryData: {
            	usercode: null,
		  },
		  supplierData:{},
        }
    },
	created(){
		this.queryData.usercode = this.$route.query.usercode;
		this.queryOne();

	},
    methods:{
		goBack(){
			this.$router.push({path:'/personal/supplierList'});
		},
		//查询单个供应商信息
		queryOne(){
			supplierListService.queryOne(this.queryData).then(response => {
				console.log(response,'查询单个供应商信息')
				this.supplierData = response.obj;
				if(this.supplierData.isQuality == 1){
					this.supplierData.isQuality = '1';
				}else if(this.supplierData.isQuality == 0){
					this.supplierData.isQuality = '0';
				}
				this.refid = response.obj.userName;
				this.isShow = true;
			})
		},
       selectC(item) {
            this.categorys = item;
            console.log(this.categorys)
        },
        tuichu(){
            this.$msg.confirm("确认退出？",()=> {
                this.$store.commit("LOGOUT")
            })
        }
    }
}
</script>

<style scoped lang="scss">
// .categoryBox {
//     display: flex;
//     border-bottom: 1px solid #dcdfe1;
// }
// .containImgBox{
// 	width: 100%;
// 	margin-top: 30px;
// 	.headBox{
// 		width: 200px;
// 		height: 200px;
// 		overflow: hidden;
// 		margin: 0 auto;
// 		img{
// 			width: 100%;
// 			height: 100%;
// 		}
// 	}
// 	.btngroup{
// 		text-align: center;
// 		margin-top: 20px;
// 	}
// }
// .categoryBox .category {
//     width: 122px;
//     height: 36px;
//     color: #b0b0b0;
//     font-size: 0.2rem;
//     text-align: center;
//     line-height: 36px;
//     margin-left: 20px;
//     border: 1px solid #b4b4b4;
//     cursor: pointer;
//     border-bottom: 0;
// }
// .categoryBox .category:first-child{
//     margin-left: 0;
// }
// .categoryBox .category.active {
//     color: #fff;
//     border: 1px solid #0e75e9;
//     background: #0e75e9;
// }
</style>
<style>

 .h-formbLine .el-form-item__label{
	width: 31%;
	text-align: right;
}
 .h-formbLine .el-form-item__content{
	width: 69%;
}
.h-formbLine .h-elformWrap-2{
	width: 33.333%;
	padding-right: 0.5rem
}

.zizhi .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 13.2%!important;
}
.zizhi .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 30.2%!important;
}
/* .h-formbLine .myfullWid{
	width: 100%!important;
}
.h-formbLine .myfullWid .el-form-item__label{
	width: 9.7%;
}
.h-formbLine .myfullWid .el-form-item__content{
	width: 90.2%;
} */
/* 
 .h-formbLine .h-elformWrap-1{
	width: 100%;
	padding-right: 0.5rem
}
 .h-formbLine .h-elformWrap-1 .el-form-item__label{
	width: 9.7%;
} */
/* .weekplandetail .h-formbLine .h-elformWrap-1 .el-form-item__content{
	width: 90.3%;
} */
</style>
